import { FC } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { AttachmentFilter } from './filters/attachment-filter.component';
import { ChannelFilter } from './filters/channel-filter.component';
import { SearchBar } from './search-bar.component';

export const KeywordSearchWithFilters: FC = () => {
  return (
    <div css={styles.container}>
      <SearchBar />
      <div css={styles.filtersContainer}>
        <ChannelFilter />
        <AttachmentFilter />
      </div>
    </div>
  );
};

const styles = {
  container: css({
    padding: theme.spacing(0.5, 1, 0, 1),
  }),
  filtersContainer: css({
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1.5),
    width: '100%',

    '.dropdownOption': {
      display: 'flex',
      alignItems: 'center',
    },

    '.dropdownFilterChipField': {
      outline: 'none',
      flex: 1,
      height: '24px',

      p: {
        fontSize: theme.font.size.small,
        fontWeight: theme.font.weight.bold,
      },

      '.label': {
        fontSize: theme.font.size.small,
        fontWeight: theme.font.weight.bold,
      },
      '.label-prefix': {
        fontSize: theme.font.size.small,
        fontWeight: theme.font.weight.bold,
      },
    },
    '.dropdownFilterChipField[aria-expanded="true"]': {
      borderColor: theme.colorsV2.blue50(),
    },
  }),
};
